module.exports = __webpack_public_path__ + "static/elevation-wrong-layer-dont-730463eba142e5919e4e7c2f94aef43a.png";